import { useQuery } from '@tanstack/react-query';
import { statsApi } from '@/api/stats';

export function useDashboardStats() {
  return useQuery({
    queryKey: ['stats', 'dashboard'],
    queryFn: () => statsApi.getDashboard(),
    refetchInterval: 30000, // Atualiza a cada 30 segundos
  });
}
